module.exports = __webpack_public_path__ + "static/media/product_4.9d7eb5b5.jpg";